import React from 'react';
import { mergeStyleSets } from '@fluentui/react';

const classes = mergeStyleSets({
    title: {
        display: 'block',
        fontSize: 20,
        fontWeight: 600,
        color: '#222',
        margin: '10px 0 4px 12px',
        lineHeight: '1.2',
    },
});

interface IBreadcrumbComponentProps {
    items: string[];
};

const BreadcrumbComponent = (props: IBreadcrumbComponentProps) => {
    const title = props.items[props.items.length - 1] || '';
    return (
        <span className={classes.title}>{title}</span>
    );
};

export default BreadcrumbComponent;
